import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// types
import { getCredit, getTransactions, downloadTransactions } from "./thunk";
interface initialStateType {
    credit: {
        data: any;
        error: object | null;
        loading: boolean;
    }
    transactions: {
        data: any;
        error: object | null;
        loading: boolean;
    }
    downloadTransactions: {
        data: any;
        error: object | null;
        loading: boolean;
    }
}

interface Error {
    error: object
}

export const initialState: initialStateType = {
    credit: {
        data: null,
        error: null,
        loading: false
    },
    transactions: {
        data: [],
        error: null,
        loading: false
    },
    downloadTransactions: {
        data: null,
        error: null,
        loading: false
    }
};

const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState,
    reducers: {
        resetDownloadError: (state: initialStateType) => {
            state.downloadTransactions.error = null;
        }
    },
    extraReducers: (builder: any) => {
        builder.addCase(getCredit.pending, (state: initialStateType) => {
            state.credit.loading = true;
        });
        builder.addCase(getCredit.fulfilled, (state: initialStateType, action: PayloadAction<any[]>) => {
            state.credit.data = action.payload;
            state.credit.loading = false;
            state.credit.error = null;
        });

        builder.addCase(getCredit.rejected, (state: initialStateType, action: PayloadAction<Error | any>) => {
            state.credit.error = action.payload ? action.payload?.error : 'Error fetching credit';
            state.credit.loading = false;
        });

        builder.addCase(getTransactions.pending, (state: initialStateType) => {
            state.transactions.loading = true;
        });

        builder.addCase(getTransactions.fulfilled, (state: initialStateType, action: PayloadAction<any[]>) => {
            state.transactions.data = action.payload.reverse();
            state.transactions.loading = false;
            state.transactions.error = null;
        });

        builder.addCase(getTransactions.rejected, (state: initialStateType, action: PayloadAction<Error | any>) => {
            state.transactions.error = action.payload ? action.payload?.error : 'Error fetching transactions';
            state.transactions.loading = false;
        });

        builder.addCase(downloadTransactions.pending, (state: initialStateType) => {
            state.downloadTransactions.loading = true;
        });

        builder.addCase(downloadTransactions.fulfilled, (state: initialStateType, action: PayloadAction<any[]>) => {
            state.downloadTransactions.data = action.payload;
            state.downloadTransactions.loading = false;
            state.downloadTransactions.error = null;
        });

        builder.addCase(downloadTransactions.rejected, (state: initialStateType, action: PayloadAction<Error | any>) => {
            state.downloadTransactions.error = action.payload ? action.payload?.error : 'Error downloading transactions';
            state.downloadTransactions.loading = false;
        });
    }
})

export const { resetDownloadError } = dashboardSlice.actions;
export default dashboardSlice.reducer;